'use client';

import { Fragment } from 'react';

import { type EnergyEfficiencyFlagSpecificProps } from '@packages/shared/src/ui/EnergyEfficiencyFlag/EnergyEfficiencyFlag';
import type { EfficiencyFlagOverlay } from '@packages/modules/src/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { EfficiencyFlagOverlayDialog } from '@packages/modules/src/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { EnergyEfficiencyFlagLocalized } from '../EfficiencyFlagLocalized/EnergyEfficiencyFlagLocalized/EnergyEfficiencyFlagLocalized';
import { ProductCardV2DatasheetLink, type Datasheet } from './ProductCardV2.DatasheetLink';

export type ProductCardV2EnergyEfficiencyFlagsProps = {
  flags: ReadonlyArray<
    EnergyEfficiencyFlagSpecificProps & {
      overlay?: EfficiencyFlagOverlay;
      datasheet?: Datasheet;
    }
  >;
};

export const ProductCardV2EnergyEfficiencyFlags = ({
  flags,
}: ProductCardV2EnergyEfficiencyFlagsProps) => (
  <div className="grid [grid-template-columns:auto_1fr] items-center gap-1">
    {flags.map(({ datasheet, overlay, ...flagProps }, index) => {
      const componentId = `efficiency-component-${overlay?.title ?? index}`;

      return (
        <Fragment key={overlay?.title ?? index}>
          <EfficiencyFlagOverlayDialog overlay={overlay} aria-describedby={componentId}>
            <EnergyEfficiencyFlagLocalized {...flagProps} />
          </EfficiencyFlagOverlayDialog>

          <div className="flex flex-col">
            {flags.length > 1 && overlay && (
              <span id={componentId} className="text-size-body-xs font-semibold hyphens-auto">
                {overlay.title}
              </span>
            )}
            {datasheet && (
              <ProductCardV2DatasheetLink datasheet={datasheet} ariaDescribedBy={componentId} />
            )}
          </div>
        </Fragment>
      );
    })}
  </div>
);
